import { motion } from "framer-motion";

const tabs = [
  {
    label: "Pubblicazioni",
    intro:
      "Elenco completo delle pubblicazioni scientifiche indicizzate su PubMed, la banca dati biomedica del National Institutes of Health (NIH).",
    items: [
      {
        anno: "PubMed",
        titolo: "Consulta l'elenco aggiornato delle pubblicazioni indicizzate.",
        rivista: "Fonte: pubmed.ncbi.nlm.nih.gov",
      },
    ],
    cta: {
      label: "Apri ricerca su PubMed",
      href: "https://pubmed.ncbi.nlm.nih.gov/?term=Gotti+M%5BAuthor%5D",
    },
  },
  {
    label: "Studi clinici",
    intro:
      "Studi clinici registrati su ClinicalTrials.gov con la partecipazione del Dott. Gotti, in ambito ematologico (linfomi, leucemie e mielomi).",
    items: [
      {
        anno: "ClinicalTrials",
        titolo: "Consulta l'elenco degli studi clinici registrati.",
        rivista: "Fonte: clinicaltrials.gov (U.S. National Library of Medicine)",
      },
    ],
    cta: {
      label: "Apri ricerca su ClinicalTrials.gov",
      href: "https://clinicaltrials.gov/search?term=Gotti+Manuel",
    },
  },
  {
    label: "Congressi",
    intro:
      "Relazioni, comunicazioni e partecipazioni a congressi nazionali e internazionali di ematologia.",
    items: [
      { anno: "In aggiornamento", titolo: "Programma congressuale in aggiornamento", rivista: "" },
    ],
  },
];

export default function RicercaInnovazione() {
  return (
    <section
      id="ricerca"
      data-testid="ricerca-section"
      className="py-24 md:py-32 bg-[#EFECE7]"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="eyebrow">Ricerca e innovazione</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-[#1A1D1A]">
              Attività <span className="italic text-[#8A6D56]">scientifica</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 text-base text-[#5C635E] leading-relaxed">
            L&apos;aggiornamento continuo e la partecipazione a progetti di ricerca sono
            parte integrante della pratica clinica. Di seguito uno spazio dedicato a
            pubblicazioni, studi e congressi.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {tabs.map((t, i) => (
            <motion.article
              key={t.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`ricerca-card-${t.label.toLowerCase()}`}
              className="bg-white border border-[#E5E1D8] rounded-2xl p-8 flex flex-col"
            >
              <p className="eyebrow text-[#8A6D56]">
                {String(i + 1).padStart(2, "0")} —{" "}
                <span className="text-[#5C635E]">Sezione</span>
              </p>
              <h3 className="font-serif-display text-[26px] md:text-3xl mt-4 leading-tight text-[#1A1D1A]">
                {t.label}
              </h3>
              <p className="text-[14px] text-[#5C635E] leading-relaxed mt-4">
                {t.intro}
              </p>

              <ul className="mt-8 border-t border-[#E5E1D8] pt-6 space-y-5 flex-1">
                {t.items.map((item, idx) => (
                  <li key={idx} className="flex gap-4">
                    <span className="font-serif-display text-lg text-[#8A6D56] shrink-0 w-24">
                      {item.anno}
                    </span>
                    <span className="text-[14px] text-[#1A1D1A]/85 leading-relaxed">
                      {item.titolo}
                      {item.rivista ? (
                        <span className="block text-xs text-[#5C635E] mt-1 italic">
                          {item.rivista}
                        </span>
                      ) : null}
                    </span>
                  </li>
                ))}
              </ul>

              <p className="text-[11px] uppercase tracking-[0.2em] text-[#5C635E] mt-8 pt-6 border-t border-[#E5E1D8]">
                {t.cta ? "" : "Sezione predisposta — contenuti in arrivo"}
              </p>
              {t.cta ? (
                <a
                  href={t.cta.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`ricerca-cta-${t.label.toLowerCase()}`}
                  className="inline-flex self-start items-center gap-2 px-6 py-3 rounded-full bg-[#8A6D56] text-white text-sm font-semibold hover:bg-[#735A47] transition-colors duration-200 -mt-3"
                >
                  {t.cta.label}
                  <span aria-hidden>↗</span>
                </a>
              ) : null}
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
